import { Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Select, Tab, Tabs, TextField, Typography, BaseTextFieldProps, MenuItem, CircularProgress, Container, Stack, Avatar, Skeleton, Radio, RadioGroup } from '@mui/material'
import React, { useState, useRef, useEffect } from 'react'
import { AmyPorterfield, clientPointWhite, dolbyWhite, ewLogo, fb, foundrWhite, keapWhite, linkdin, Logo, LogoDarkMode, mail, microsoft, dayTrialCloud, susieMoore, teachableWhite, } from '../assets/images'
import { GoogleIcon, LinkedInsmallIcon, MicrosoftIcon, RightArrow, TickSymbolThin } from '../assets/icons'
import Grid from '@mui/material/Grid2'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarHalfRoundedIcon from '@mui/icons-material/StarHalfRounded';
import umbrellaSignBg from "../assets/images/umbrellaSignBg.png"
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import { CheckboxProps } from '@mui/material/Checkbox';
import 'react-international-phone/style.css';
import { CountryIso2, defaultCountries, FlagImage, parseCountry, usePhoneInput, } from 'react-international-phone';
import AuthService from '../services/auth.service'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AccountVerification from '../modals/AccountVerification'
import moment from 'moment-timezone';
import { CardComponent } from "@chargebee/chargebee-js-react-wrapper";
import chargebeeService from '../services/chargebee.service'
import { Applications } from '../types/enums'
import { toast } from 'react-toastify'
import { SocialProvider } from '../types/auth'
import { config } from '../config'
import theme from '../theme'
import { LIVE_PRICES, AUTOMATED_PRICES, LIVE_AUTO_PRICES, PricingTier } from '../components/subscription/pricing/pricingData';
import { formatPlanName, validateEmail, generateSecurePassword } from '../utils/common.util'
import { LeadsquaredService } from '../services/leadsquared/leadsquared.service'
import { GhlService } from '../services/ghl'
import { PLAN_NAMES } from '../constants/planNames'
import { ArrowForward, ArrowBack, People } from '@mui/icons-material'
import EventsLoggerService from '../services/events-logger.service'
import { 
    SIGNUP_FLOWS,
    logEvent,
    EVENT_TYPES,
    SIGNUP_STEPS
} from '../utils/events.util'
import PasswordStrengthIndicator from '../components/common/PasswordStrengthIndicator'


interface TabPanelProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    index: number;
    value: number;
    noPadding?: boolean;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, noPadding, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: noPadding ? 0 : 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

// Plan configuration for Sale
interface PlanConfig {
    planId: string;
    planName: string;
    price: number;
    regularYearlyPrice: number;
    attendees: string; // e.g., "200 Live + 1,000 Automated"
    features: string[];
    savingsBreakdown: {
        regularPrice: string;
        savingsPercentage: string;
        monthlyEquivalent: string;
        note?: string;
    };
    upgradeText?: string; // Text for upgrade section
}

const PLAN_CONFIGS: Record<string, PlanConfig> = {
    'All-In-One-USD-Yearly-200': {
        planId: 'All-In-One-USD-Yearly-200',
        planName: 'Professional',
        price: 696, // Yearly price
        regularYearlyPrice: 1392, // 116 * 12
        attendees: '200 Live + 1,000 Automated',
        features: [
            'EasySuite CRM (brand-new inbuilt sales CRM — no integrations needed)',
            'Community and monthly workshop access',
            'Complete webinar funnel setup (worth $1,000)',
            'Priority onboarding & support'
        ],
        savingsBreakdown: {
            regularPrice: '$116/month (≈ $1,392/year)',
            savingsPercentage: 'You save $696/year (~50% vs. paying monthly)',
            monthlyEquivalent: '$58/month when paid annually',
        },
        //upgradeText: 'Upgrade to Professional Plus — just $492 more for 500 live / 2,500 automated attendees + AI Webinar Builder & Paid Webinars (beta).'
    },
    'All-In-One-USD-Yearly-500': {
        planId: 'All-In-One-USD-Yearly-500',
        planName: 'Professional Plus',
        price: 1188, // Yearly price
        regularYearlyPrice: 9664, // 198 * 12
        attendees: '500 Live + 2,500 Automated',
        features: [
            'EasySuite CRM (brand-new inbuilt sales CRM — no integrations needed)',
            'AI Webinar Builder (beta)',
            'Paid Webinars (beta)',
            'Community and monthly workshop access',
            'Complete webinar funnel setup (worth $1,000)',
            'Priority onboarding & support'
        ],
        savingsBreakdown: {
            regularPrice: '$198/month (≈ $2,376/year)',
            savingsPercentage: 'You save $1,188/year (~50% vs. paying monthly)',
            monthlyEquivalent: '$99/month when paid annually'
        }
    },
    'Automated-Gold-USD-Yearly-6000': {
        planId: 'Automated-Gold-USD-Yearly-6000',
        planName: 'Scale',
        price: 1452, // Yearly price
        regularYearlyPrice: 2904, // 242 * 12
        attendees: '6,000 Automated (Simulive and Evergreen)',
        features: [
            'EasySuite CRM (your inbuilt sales CRM)',
            'AI Webinar Builder (beta)',
            'Paid Webinars (beta)',
            'Community and workshop access',
            'Complete webinar funnel setup (worth $1,000)',
            'Priority onboarding & support'
        ],
        savingsBreakdown: {
            regularPrice: '$242/month (≈ $2,904/year)',
            savingsPercentage: 'You save $1,452/year (~50% vs. paying monthly)',
            monthlyEquivalent: '$121/month when paid annually'
        }
    }
};

const WorkshopBundleAnnual = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = React.useState(false);
    const [showPromoField, setShowPromoField] = useState(false);
    const [value, setValue] = React.useState(1);
    const [passwordError, setPasswordError] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [termsError, setTermsError] = useState('');
    const [leadSquaredId, setLeadSquaredId] = useState<string>('');
    const [ghlContactId, setGhlContactId] = useState<string>('');
    const [cards] = useState([
        {
            name: "Amy Porterfield",
            title: "Online Marketing Expert",
            testimonial: `"I personally use EasyWebinar and they are the best. I moved from using other platforms and nothing compares to their reliability and customer support!"`,
            avatar: "https://www.amyporterfield.com/wp-content/uploads/2022/12/Amy-Porterfield-Headshot-Course-Creator-2-2-scaled.jpg"
        }
    ]);

    const getTimezoneString = () => {
        const timezone = moment.tz.guess() || "UTC";
        const offset = moment.tz(timezone).format("Z");
        const zoneName = moment.tz(timezone).zoneName();
        return `(GMT${offset}),${timezone},${zoneName}`;
    };

    const generateFirstName = (email: string) => {
        const emailParts = email.split("@")[0];
        const name = emailParts
            .split(/[._-]/)
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
            .join(" ");
        return name;
    };

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        timezone: getTimezoneString(),
        subdomain: ''
    });

    // Auto-generate strong password on component mount
    useEffect(() => {
        const autoGeneratedPassword = generateSecurePassword();
        setFormData(prev => ({
            ...prev,
            password: autoGeneratedPassword
        }));
    }, []);
    const [formErrors, setFormErrors] = useState({
        email: '',
        password: '',
        subdomain: ''
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isCardReady, setIsCardReady] = useState(false);
    const [isCardValid, setIsCardValid] = useState(false);

    const [verificationData, setVerificationData] = useState({
        companyId: '',
        companyName: '',
        infLeadSquaredId: ''
    });

    const [cardToken, setCardToken] = useState<string>("");
    const [cardError, setCardError] = useState<string | null>(null);
    const cardRef = useRef<any>(null);
    const hasAutoAdvancedRef = useRef<boolean>(false);
    const hasProcessedRef = useRef<boolean>(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [isTrial, setIsTrial] = useState(false);
    const [noTrial, setNoTrial] = useState(false);

    const [promoCode, setPromoCode] = useState('');
    const [appliedPromo, setAppliedPromo] = useState<{
        code: string;
        discount: number;
        type: string;
    } | null>(null);
    const [promoError, setPromoError] = useState('');

    const [domainSuggestions, setDomainSuggestions] = useState<string[]>([]);
    const [currentPlanConfig, setCurrentPlanConfig] = useState<PlanConfig | null>(null);

    // Allowed planIds
    const ALLOWED_PLAN_IDS = [
        'All-In-One-USD-Yearly-200',
        'All-In-One-USD-Yearly-500',
        'Automated-Gold-USD-Yearly-6000'
    ];
    const DEFAULT_PLAN_ID = 'All-In-One-USD-Yearly-500';

    const planIdParam = searchParams.get('planId');
    
    // Validate and set default planId if needed
    useEffect(() => {
        if (!planIdParam || !ALLOWED_PLAN_IDS.includes(planIdParam)) {
            setSearchParams((prev) => {
                prev.set("planId", DEFAULT_PLAN_ID);
                return prev;
            }, { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [planIdParam]);

    // Use validated planId or default
    const planId = planIdParam && ALLOWED_PLAN_IDS.includes(planIdParam) ? planIdParam : DEFAULT_PLAN_ID;

    // Helper function to get base planId for API requests (without the number)
    const getBasePlanId = () => {
        // Remove the number at the end to get base planId (e.g., "All-In-One-USD-Yearly-200" -> "All-In-One-USD-Yearly")
        return planId.replace(/-\d+$/, '');
    };

    // Helper function to get planUnits from planId
    const getPlanUnits = () => {
        const match = planId.match(/-(\d+)$/);
        return match ? parseInt(match[1], 10) : 200;
    };



    const handleUpgradeClick = () => {
        setSearchParams((prev) => {
            prev.set("planId", "All-In-One-USD-Yearly-500");
            return prev;
        }, { replace: true });
        // Scroll to top to show the new plan
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Store planId in localStorage when component mounts
    useEffect(() => {
        if (planId) {
            localStorage.setItem('planId', planId);
        }
    }, [planId]);


    useEffect(() => {
        // Extract plan details from planId and console log them
        if (planId) {
            // Check if this is one of the three specific sale plans
            if (PLAN_CONFIGS[planId]) {
                const config = PLAN_CONFIGS[planId];
                setCurrentPlanConfig(config);
                return; // Exit early since we've set everything from config
            }
        }
    }, [planId]);

    const validatePassword = (password: string) => {
        const minLength = 8;
        const hasNumber = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        const hasLowercase = /[a-z]/.test(password);
        const hasUppercase = /[A-Z]/.test(password);

        if (password.length < minLength) {
            return 'Password must be at least 8 characters long';
        }
        if (!hasNumber) {
            return 'Password must contain at least one number';
        }
        if (!hasSpecialChar) {
            return 'Password must contain at least one special character';
        }
        if (!hasUppercase) {
            return 'Password must contain at least one uppercase letter';
        }
        if (!hasLowercase) {
            return 'Password must contain at least one lowercase letter';
        }
        return '';
    };



    const validateForm = () => {
        const errors = {
            email: '',
            password: '',
            subdomain: ''
        };
        let isValid = true;

        // Check required fields
        const emailValidation = validateEmail(formData.email);
        if (!emailValidation.isValid) {
            errors.email = emailValidation.error || "Please enter a valid email";
            isValid = false;
        }

        // Password validation
        if (!formData.password.trim()) {
            errors.password = 'Password is required';
            setPasswordError('Password is required');
            isValid = false;
        } else {
            const passwordValidationError = validatePassword(formData.password);
            if (passwordValidationError) {
                errors.password = passwordValidationError;
                setPasswordError(passwordValidationError);
                isValid = false;
            } else {
                setPasswordError('');
            }
        }

        setFormErrors(errors);
        return isValid;
    };


    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        // For subdomain field, convert to lowercase
        const processedValue = name === 'subdomain' ? value.toLowerCase() : value;

        // Update the form data with the raw input value
        setFormData(prev => ({
            ...prev,
            [name]: processedValue
        }));

        // Clear error when user starts typing
        setFormErrors(prev => ({
            ...prev,
            [name]: ''
        }));

        if (name === 'password') {
            if (!value.trim()) {
                setPasswordError('Password is required');
            } else {
                setPasswordError(validatePassword(value));
            }
        }
    };


    const [verificationDialogOpen, setVerificationDialogOpen] = React.useState(false);

    const handleVerificationDialogOpen = () => {
        setVerificationDialogOpen(true);
    };

    const handleVerificationDialogClose = async () => {
        setVerificationDialogOpen(false);
        const fullPlanName = planId || currentPlanConfig?.planName || '';
        const leadData = {
            "leadId": leadSquaredId,
            "fields": [
                { "Attribute": "mx_Plan_Name", "Value": currentPlanConfig?.planName || '' },
                { "Attribute": "mx_Status", "Value": "Pending Verification" }
            ]
        }
        await LeadsquaredService.updateLsField(leadData);
        if (ghlContactId) {
            await GhlService.updateContactFields({
                contactId: ghlContactId,
                fields: [
                    { key: 'plan_name', value: fullPlanName },
                    { key: 'subscription_status', value: 'Active User' },
                ],
            });
            await GhlService.addTags(ghlContactId, [fullPlanName, 'workshop-bundle-annual']);
        }
        navigate('/login');
    };

    // Helper function to clear UTM params from localStorage
    const clearUtmParamsFromStorage = () => {
        localStorage.removeItem('utm_source');
        localStorage.removeItem('utm_medium');
        localStorage.removeItem('utm_campaign');
        localStorage.removeItem('utm_content');
        localStorage.removeItem('utm_term');
        localStorage.removeItem('ad_id');
        localStorage.removeItem('fbc_id');
        localStorage.removeItem('h_ad_id');
        localStorage.removeItem('utm_id');
        localStorage.removeItem('gc_id');
        localStorage.removeItem('h_ga_id');
        localStorage.removeItem('h_keyword_id');
        localStorage.removeItem('h_keyword');
        localStorage.removeItem('h_placement');
        localStorage.removeItem('g_special_campaign');
    };

    const handleVerificationDialogProceed = async () => {
        // handleVerificationDialogClose();
        setVerificationDialogOpen(false);
        const fullPlanName = planId || currentPlanConfig?.planName || '';
        try {
            if (ghlContactId) {
                await GhlService.addTags(ghlContactId, ['email verified', fullPlanName, 'workshop-bundle-annual']);
                await GhlService.updateContactFields({
                    contactId: ghlContactId,
                    fields: [
                        { key: 'plan_name', value: fullPlanName },
                        { key: 'subscription_status', value: 'Active User' },
                    ],
                });
            }
            await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Email Verified" });
            const leadData = {
                "leadId": leadSquaredId,
                "fields": [
                    { "Attribute": "mx_Plan_Name", "Value": currentPlanConfig?.planName || '' },
                    { "Attribute": "mx_Status", "Value": "Active" }
                ]
            }
            await LeadsquaredService.updateLsField(leadData);
        } catch (error) {
            console.error('Error updating lead data:', error);
        }

        // Clear UTM parameters from localStorage after successful signup
        clearUtmParamsFromStorage();
  
        // Pass plan data through URL parameters
        const planData = {
            price: currentPlanConfig ? currentPlanConfig.price : 0,
            currency: 'USD',
            coupon: appliedPromo?.code || 'WORKSHOP50',
            plan_name: currentPlanConfig ? currentPlanConfig.planName : '',
            customer_type: "with_cc"
        };

        // Encode plan data as URL parameters
        const planDataParams = new URLSearchParams({
            ...planData,
            price: planData.price.toString()
        }).toString();

        window.location.href = `/loading-dashboard?ew_email=${formData.email}&planId=lifetime-pro-plan&${planDataParams}`;
    };


    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        // Only allow changing to the second tab (newValue = 1) if it's done programmatically
        // Users can always go back to the first tab (newValue = 0)
        if (newValue === 0) {
            setValue(newValue);
        }
        // The second tab (newValue = 1) can only be reached through handleNext function
        // which validates the form fields first
    }

    const handleSocialSignIn = (provider: SocialProvider) => {
        try {
            const authUrl = config.sso_auth_url;
            const planIdParam = searchParams.get('planId');

            const utmParams = {
                utm_source: localStorage.getItem('utm_source'),
                utm_medium: localStorage.getItem('utm_medium'),
                utm_campaign: localStorage.getItem('utm_campaign'),
                utm_content: localStorage.getItem('utm_content'),
                utm_term: localStorage.getItem('utm_term'),
                ad_id: localStorage.getItem('ad_id'),
                fbc_id: localStorage.getItem('fbc_id'),
                h_ad_id: localStorage.getItem('h_ad_id'),
                utm_id: localStorage.getItem('utm_id'),
                gc_id: localStorage.getItem('gc_id'),
                h_ga_id: localStorage.getItem('h_ga_id'),
                h_keyword_id: localStorage.getItem('h_keyword_id'),
                h_keyword: localStorage.getItem('h_keyword'),
                h_placement: localStorage.getItem('h_placement'),
                g_special_campaign: localStorage.getItem('g_special_campaign'),
            }

            // Filter out null/undefined/empty values from UTM params
            const cleanUtmParams = Object.entries(utmParams)
                .filter(([_, value]) => value !== null && value !== undefined && value.trim() !== '')
                .reduce((acc, [key, value]) => ({ ...acc, [key]: value?.trim() }), {});

            // Create state parameter with additional metadata
            const stateData = {
                isRegistration: true,
                timestamp: Date.now(),
                flow: 'first-flow',
                ...(planIdParam && { planId: planIdParam }), // Only include planId if it exists
                ...(Object.keys(cleanUtmParams).length > 0 && { utm_params: cleanUtmParams }) // Only include UTM params if they exist
            };

            const baseParams = {
                client_id: config.sso_client_id,
                response_type: 'code',
                scope: 'email openid profile phone',
                redirect_uri: `${window.location.origin}/auth/sso/callback`,
                state: JSON.stringify(stateData),
                prompt: 'select_account'
            };

            const params = new URLSearchParams({
                ...baseParams,
                identity_provider: provider,
            });

            window.location.href = `${authUrl}?${params.toString()}`;
        } catch (error) {
            console.error('Google Sign In Error:', error);
            toast.error('Failed to initialize Google Sign In');
        }
    };

    const handleGoogleSignIn = () => handleSocialSignIn('Google');
    const handleMicrosoftSignIn = () => handleSocialSignIn('Microsoft');
    const handleLinkedinSignIn = () => handleSocialSignIn('Linkedin');

    // Extracted core logic for processing step 1 to step 2 transition
    const processStepTransition = async (): Promise<{ shouldProceed: boolean; subdomain?: string }> => {
        try {
            let cardTokenResult = null;
            setIsLoading(true);

            // Validation and display errors
            const isValid = validateForm();
            if (!isValid) {
                setIsLoading(false);
                return { shouldProceed: false };
            }

            // Check if email exists
            const emailCheckResponse = await AuthService.checkEmailExists(formData.email);
            if (emailCheckResponse.data?.exists) {
                // Check if card has any validation errors
                if (cardError) {
                    toast.error('Please fix card validation errors before proceeding');
                    setIsLoading(false);
                    return { shouldProceed: false };
                }

                const result = await cardRef.current.tokenize();

                if (result.error) {
                    setCardError(result.error.message || 'Card tokenization failed');
                    toast.error('Please check your card details.');
                    setIsLoading(false);
                    return { shouldProceed: false };
                }

                cardTokenResult = result.token;
                setCardToken(cardTokenResult);
                setCardError(null);

                if (!cardTokenResult) {
                    setCardError('Please enter valid card details');
                    toast.error('Please enter valid card details');
                    setIsLoading(false);
                    return { shouldProceed: false };
                }

                try {
                    await chargebeeService.changePlanByEmail({
                        email: formData.email,
                        planId: 'All-In-One-USD-Yearly',
                        planUnits: 500,
                        cardToken: cardTokenResult,
                        couponId: appliedPromo?.code || 'WORKSHOP50'
                    });

                    logEvent(formData.email, EVENT_TYPES.BUNDLE_PURCHASE, {
                        bundleType: 'workshopBundleAnnual',
                        email: formData.email,
                        planId: 'All-In-One-USD-Yearly',
                        planUnits: 500,
                        amount: 1188,
                        flow: 'upgrade',
                        step: 'success'
                    });

                    toast.success('Plan changed successfully');
                    navigate('/login');
                    setIsLoading(false);
                    return { shouldProceed: false }; // Don't proceed further if user exists and email change worked
                } catch (error: any) {
                    console.error('Error changing plan:', error);
                    toast.error('Failed to change plan. Please try again.');
                    setIsLoading(false);
                    return { shouldProceed: false };
                }
            }

            // Auto-generate firstName and lastName from email
            const firstName = generateFirstName(formData.email);
            const lastName = "";

            // Generate subdomain from first name
            const baseSubdomain = firstName.toLowerCase().trim().replace(/\s+/g, '');
            const subdomainResponse = await AuthService.generateSubdomain(baseSubdomain, Applications.EASYWEBINAR);

            // Store the generated subdomain for use in step 2
            setFormData(prev => ({
                ...prev,
                subdomain: subdomainResponse.subdomain
            }));

            // Log signup event before moving to next step
            try {
                const eventData = {
                    step: SIGNUP_STEPS.FORM,
                    password: formData.password,
                    planId: 'All-In-One-USD-Yearly',
                    planUnits: 500,
                    signupFlow: SIGNUP_FLOWS.PRICING_PAGE,
                    planName: 'All-In-One-USD-Yearly',
                    planPrice: 1188,
                    saleType: 'WorkshopBundleAnnual'
                }
                
                await logEvent(formData.email, EVENT_TYPES.SIGNUP, eventData);
            } catch (error: any) {
                console.error('Error logging signup event:', error);
                // Don't block the flow if event logging fails
            }

            // If validation and subdomain generation passes, continue (already on step 1)
            try {
                let utm_Data = {
                    utm_source: localStorage.getItem('utm_source'),
                    utm_medium: localStorage.getItem('utm_medium'),
                    utm_campaign: localStorage.getItem('utm_campaign'),
                    utm_content: localStorage.getItem('utm_content'),
                    utm_term: localStorage.getItem('utm_term'),
                    ad_id: localStorage.getItem('ad_id'),
                    fbc_id: localStorage.getItem('fbc_id'),
                    h_ad_id: localStorage.getItem('h_ad_id'),
                    utm_id: localStorage.getItem('utm_id'),
                    gc_id: localStorage.getItem('gc_id'),
                    h_ga_id: localStorage.getItem('h_ga_id'),
                    h_keyword_id: localStorage.getItem('h_keyword_id'),
                    h_keyword: localStorage.getItem('h_keyword'),
                    h_placement: localStorage.getItem('h_placement'),
                    g_special_campaign: localStorage.getItem('g_special_campaign'),
                }

                // Create form data with generated firstName and lastName
                const formDataWithDetails = {
                    firstName,
                    lastName,
                    email: formData.email,
                    password: formData.password,
                    timezone: getTimezoneString(),
                    subdomain: subdomainResponse.subdomain,
                };

                const LsId = await LeadsquaredService.createtLead(formDataWithDetails, "", utm_Data);
                await LeadsquaredService.joinActivity({ id: LsId, activityEvent: 201, activityValue: "Signup Attempt - pricing" });
                const ghlId = await GhlService.createContact(
                    { ...formDataWithDetails, phone: '' },
                    '',
                    utm_Data
                );
                if (ghlId) {
                    setGhlContactId(ghlId);
                    const fullPlanName = planId || currentPlanConfig?.planName || '';
                    await GhlService.addTags(ghlId, [fullPlanName]);
                    await GhlService.updateContactFields({
                        contactId: ghlId,
                        fields: [
                            { key: 'plan_name', value: fullPlanName },
                            { key: 'subscription_status', value: 'Active User' },
                        ],
                    });
                }
                const leadData = {
                    "leadId": LsId,
                    "fields": [
                        { "Attribute": "mx_Source_lp", "Value": searchParams.get('Source_IP'), },
                    ]
                }
                await LeadsquaredService.updateLsField(leadData);
                setLeadSquaredId(LsId);
            } catch (error: any) {
                console.error('Error creating lead:', error);
            }
            
            return { shouldProceed: true, subdomain: subdomainResponse.subdomain }; // Proceed with the flow and return subdomain
        } catch (error: any) {
            console.error('Error generating subdomain:', error);
            toast.error('Failed to generate subdomain. Please try again.');
            return { shouldProceed: false };
        } finally {
            setIsLoading(false);
        }
    };

    const handleGetStarted = async () => {
        // First, process step transition (validate email, check if exists, generate subdomain, create lead)
        const result = await processStepTransition();
        if (!result.shouldProceed) {
            return; // Don't proceed further if user exists and email change worked
        }
        try {
            setIsLoading(true);

            // Ensure formData.subdomain is set from the returned subdomain if available
            if (result.subdomain && !formData.subdomain) {
                setFormData(prev => ({
                    ...prev,
                    subdomain: result.subdomain!
                }));
            }

            // Use the subdomain from processStepTransition, fallback to formData.subdomain if not available
            const subdomainToCheck = result.subdomain || formData.subdomain;

            // Check domain availability first
            const domainResponse = await AuthService.checkSubDomainAvailability(
                subdomainToCheck,
                Applications.EASYWEBINAR
            );

            if (!domainResponse.available) {
                setFormErrors(prev => ({
                    ...prev,
                    subdomain: 'This domain is already taken. Please try another one.'
                }));
                // Set domain suggestions if they exist
                if (domainResponse.suggestions && domainResponse.suggestions.length > 0) {
                    setDomainSuggestions(domainResponse.suggestions);
                } else {
                    setDomainSuggestions([]);
                }
                setIsLoading(false);
                return;
            }

            // Clear suggestions if domain is available
            setDomainSuggestions([]);

            let cardTokenResult = null;
            const planId = 'All-In-One-USD-Yearly'

            // Only process card if there's a plan and it's not a free trial
            if (planId && !isTrial) {
                // Check if card has any validation errors
                if (cardError) {
                    toast.error('Please fix card validation errors before proceeding');
                    setIsLoading(false);
                    return;
                }

                const result = await cardRef.current.tokenize();

                if (result.error) {
                    setCardError(result.error.message || 'Card tokenization failed');
                    toast.error('Please check your card details.');
                    setIsLoading(false);
                    return;
                }

                cardTokenResult = result.token;
                setCardToken(cardTokenResult);
                setCardError(null);

                if (!cardTokenResult) {
                    setCardError('Please enter valid card details');
                    toast.error('Please enter valid card details');
                    setIsLoading(false);
                    return;
                }
            }

            // Get UTM parameters directly from URL
            const urlParams = new URLSearchParams(window.location.search);

            const utmParams = {
                utm_source: urlParams.get('utm_source'),
                utm_medium: urlParams.get('utm_medium'),
                utm_campaign: urlParams.get('utm_campaign'),
                utm_content: urlParams.get('utm_content'),
                utm_term: urlParams.get('utm_term'),
                ad_id: urlParams.get('ad_id'),
                fbc_id: urlParams.get('fbc_id'),
                h_ad_id: urlParams.get('h_ad_id'),
                utm_id: urlParams.get('utm_id'),
                gc_id: urlParams.get('gc_id'),
                h_ga_id: urlParams.get('h_ga_id'),
                h_keyword_id: urlParams.get('h_keyword_id'),
                h_keyword: urlParams.get('h_keyword'),
                h_placement: urlParams.get('h_placement'),
                g_special_campaign: urlParams.get('g_special_campaign'),
            };

            // Remove null/undefined values from the UTM params object
            const cleanUtmParams = Object.entries(utmParams)
                .filter(([_, value]) => value !== null && value !== undefined)
                .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

            // Check if buyNow parameter is present and true
            const buyNow = urlParams.get('BuyNow') == 'true';


            // Generate firstName and lastName from email
            const firstName = generateFirstName(formData.email);
            const lastName = "";

            const signupData = {
                ...formData,
                firstName,
                lastName,
                phoneNumber: "",
                subdomain: subdomainToCheck,
                timezone: getTimezoneString(),
                planId: getBasePlanId(),
                planUnits: getPlanUnits(),
                cardToken: cardTokenResult,
                trialEnd: noTrial ? 0 : undefined,
                couponId: appliedPromo?.code || 'WORKSHOP50',
                // Include UTM parameters if they exist
                ...(Object.keys(cleanUtmParams).length > 0 && { utm_params: cleanUtmParams })
            };

            const response = await AuthService.signup(signupData);

            setVerificationData({
                companyId: response.data.companyId || '',
                companyName: response.data.companyName || '',
                infLeadSquaredId: response.data.inf_lead_squared_id || ''
            });
            handleVerificationDialogOpen();

            // Clear UTM params on successful signup
            clearUtmParamsFromStorage();
            toast.success('Signup successful! Please verify your account.');
            try {
                await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Waiting To Confirm Email Validation" });
                
                const activityNote = `${currentPlanConfig?.planName || ''} - ${getPlanUnits()} - Holiday Sale`;
                await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: getBasePlanId() || '', activityNote: activityNote });
            } catch (error: any) {
                console.error('Error joining activities:', error);
            }
        } catch (error: any) {
            console.error('Signup failed:', error);
            setDomainSuggestions([]);
            // Clear UTM params on signup failure too
            clearUtmParamsFromStorage();
            if (error.name === 'INVALID_CARD') {
                setCardError('Please enter valid card details');
                toast.error('Invalid card details. Please try again.');
            } else {
                toast.error(error.message || 'An error occurred during signup. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const validateCoupon = async (codeToValidate?: string) => {
        const code = codeToValidate || promoCode.trim();
        if (!code) {
            setPromoError('Please enter a promo code');
            toast.error('Please enter a promo code');
            return;
        }

        try {
            const response = await chargebeeService.validateCoupon(
                code,
                getBasePlanId()
            );

            if (response.data.valid) {
                const { coupon } = response.data;
                setAppliedPromo({
                    code: coupon.id,
                    discount: coupon.discountPercentage || coupon.discountAmount,
                    type: coupon.discountType
                });
                setPromoError('');
                setShowPromoField(false);
                if (!codeToValidate) {
                    toast.success('Promo code applied successfully!');
                }
            } else {
                setPromoError(response.data.error || 'Invalid promo code');
                setAppliedPromo(null);
                if (!codeToValidate) {
                    toast.error(response.data.error || 'Invalid promo code');
                }
            }
        } catch (error: any) {
            console.error('Error validating coupon:', error);
            setPromoError('Failed to validate promo code');
            setAppliedPromo(null);
            if (!codeToValidate) {
                toast.error('Failed to validate promo code. Please try again.');
            }
        }
    };

    // Auto-apply promo code
    useEffect(() => {
        const autoApplyPromo = async () => {
            if (!appliedPromo && planId) {
                await validateCoupon('WORKSHOP50');
            }
        };
        autoApplyPromo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [planId]);

    // Inside the Signup component, add a state variable for planFeatures
    const [planFeatures, setPlanFeatures] = useState<{
        planType: string;
        currency: string;
        duration: string;
        attendees: number;
        liveAttendees?: number;
        automatedAttendees?: number;
        price: number | string;
        webinars: number | string;
        storage: string;
    } | null>(null);

    // Add new state variables to store the extracted values
    const [planType, setPlanType] = useState<string>('');
    const [leads, setLeads] = useState<number>(0);
    const [liveAttendees, setLiveAttendees] = useState<number | undefined>(undefined);
    const [automatedAttendees, setAutomatedAttendees] = useState<number | undefined>(undefined);
    const [planPrice, setPlanPrice] = useState<number | string>('');
    const [planWebinars, setPlanWebinars] = useState<number | string>('');
    const [planStorage, setPlanStorage] = useState<string>('');

    function captureUTMParams() {
        const urlParams = new URLSearchParams(window.location.search);

        const utmSource = urlParams.get('utm_source');
        const utmMedium = urlParams.get('utm_medium');
        const utmCampaign = urlParams.get('utm_campaign');
        const utmContent = urlParams.get('utm_content');
        const utmTerm = urlParams.get('utm_term');
        const email = urlParams.get('email');
        const ad_id = urlParams.get('ad_id');
        const fbc_id = urlParams.get('fbc_id');
        const h_ad_id = urlParams.get('h_ad_id');
        const utm_id = urlParams.get('utm_id');
        const gc_id = urlParams.get('gc_id');
        const h_ga_id = urlParams.get('h_ga_id');
        const h_keyword_id = urlParams.get('h_keyword_id');
        const h_keyword = urlParams.get('h_keyword');
        const h_placement = urlParams.get('h_placement');
        const g_special_campaign = urlParams.get('g_special_campaign');

        if (utmSource) localStorage.setItem('utm_source', utmSource);
        if (utmMedium) localStorage.setItem('utm_medium', utmMedium);
        if (utmCampaign) localStorage.setItem('utm_campaign', utmCampaign);
        if (utmContent) localStorage.setItem('utm_content', utmContent);
        if (utmTerm) localStorage.setItem('utm_term', utmTerm);
        
        if (ad_id) localStorage.setItem('ad_id', ad_id);
        if (fbc_id) localStorage.setItem('fbc_id', fbc_id);
        if (h_ad_id) localStorage.setItem('h_ad_id', h_ad_id);
        if (utm_id) localStorage.setItem('utm_id', utm_id);
        if (gc_id) localStorage.setItem('gc_id', gc_id);
        if (h_ga_id) localStorage.setItem('h_ga_id', h_ga_id);
        if (h_keyword_id) localStorage.setItem('h_keyword_id', h_keyword_id);
        if (h_keyword) localStorage.setItem('h_keyword', h_keyword);
        if (h_placement) localStorage.setItem('h_placement', h_placement);
        if (g_special_campaign) localStorage.setItem('g_special_campaign', g_special_campaign);
        // Set email from URL parameter if present
        if (email) {
            setFormData(prev => ({
                ...prev,
                email: email
            }));
        }
    }

    // Add useEffect for capturing UTM parameters
    useEffect(() => {
        captureUTMParams();
    }, []);

    // Auto-process step transition logic if email is in URL params (runs in background)
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const emailFromUrl = urlParams.get('email');
        
        // Check if email is in URL, formData.email matches it, password is set, and haven't processed yet
        // Only process once when all conditions are met
        if (emailFromUrl && 
            formData.email === emailFromUrl && 
            formData.email && 
            formData.password && 
            !hasProcessedRef.current) {
            hasProcessedRef.current = true;
            // Process the step transition logic in the background (validation, subdomain generation, lead creation)
            processStepTransition();
        }
    }, [formData.email, formData.password]); // eslint-disable-line react-hooks/exhaustive-deps

    // Check for BuyNow parameter on page load
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const buyNow = urlParams.get('BuyNow') === 'true';
        setNoTrial(true);
    }, []);

    return (
        <>            
            <Box
                sx={{
                    minHeight: "100vh",
                    width: "100vw",
                    background: `
                linear-gradient(180deg, #010007 26.92%, #AC8DFF 100%),
                linear-gradient(180deg, #FFFFEF 0%, #FFF 100%)
            `,
                    color: "#1f2937",
                    fontFamily: "Inter",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: { xs: "16px 24px", sm: "24px 32px" },
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={LogoDarkMode}
                            alt="logo"
                            style={{ height: 24, cursor: "pointer", maxWidth: "100%" }}
                            onClick={() => window.open("https://easywebinar.com/", "_blank")}
                        />
                    </Box>
                    <Button
                        variant="contained"
                        endIcon={<ArrowForward />}
                        size="small"
                        onClick={() => navigate("/login")}
                        sx={{
                            bgcolor: "#6066E9",
                            color: "#fff",
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 600,
                            "&:hover": { bgcolor: "#4B4EB5" },
                        }}
                    >
                        Login
                    </Button>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: {
                            xs: "calc(100vh - 120px)",
                            sm: "calc(100vh - 100px)",
                            md: "calc(100vh - 80px)",
                        },
                        p: { xs: 1, sm: 2 },
                        pt: { xs: 1, sm: 2, md: 3 },
                    }}
                >
                    {/* Main container with border - responsive sizing */}
                    <Box
                        sx={{
                            width: { xs: "100%", sm: "90%", md: "1200px", lg: "1400px" },
                            maxWidth: { xs: "600px", md: "none" },
                            height: { xs: "auto" },
                            border: "1.5px solid #e5e7eb",
                            borderRadius: "18px",
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            bgcolor: "#ffffff",
                            boxShadow: "0 4px 32px 0 rgba(0,0,0,0.1)",
                            overflow: "hidden",
                        }}
                    >
                        {/* Left side - Promotional Section */}
                        <Box
                            sx={{
                                width: "50%",
                                bgcolor: "#f8fafc",
                                p: { xs: 3, sm: 4, md: 6 },
                                display: { xs: "none", md: "flex" },
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                borderRadius: { xs: "18px", md: "18px 0 0 18px" },
                                minHeight: { xs: "500px", md: "auto" },
                            }}
                        >
                            <Box sx={{ textAlign: 'left', width: '100%' }}>
                                {/* Light Blue-Gray Panel */}
                                    <Box
                                        sx={{
                                            backgroundColor: '#F0F4F8',
                                            borderRadius: '12px',
                                            padding: '24px',
                                            mb: '24px',
                                        }}
                                    >
                                        {/* Plan Name Header - Centered */}
                                        <Typography
                                            variant="h4"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: { xs: '18px', sm: '20px', md: '22px' },
                                                fontWeight: 700,
                                                mb: '24px',
                                                textAlign: 'center',
                                                textDecoration: 'underline',
                                            }}
                                        >
                                            Professional Plus Bundle (Annual Access)
                                        </Typography>

                                        {/* What's Included Section */}
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: { xs: '18px', md: '20px' },
                                                fontWeight: 700,
                                                mb: '16px',
                                            }}
                                        >
                                            What's Included :
                                        </Typography>

                                        <Box sx={{ mb: '24px' }}>
                                            {/* Item 1: EasyWebinar Professional */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    EasyWebinar Professional (12 Months) – FREE ($2,376 value)
                                                </Typography>
                                            </Box>

                                            {/* Item 2: EasyCRM Sales Engine */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    EasyCRM Sales Engine – FREE ($1,200+ value)
                                                </Typography>
                                            </Box>

                                            {/* Item 3: Elite Webinar Mastery Course */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    Elite Webinar Mastery Course ($1,300 value)
                                                </Typography>
                                            </Box>

                                            {/* Item 4: Monthly Webinar Pass */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    Monthly Webinar Pass (12 Months) ($600 value)
                                                </Typography>
                                            </Box>

                                            {/* Item 5: Sales Experience Community */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    Sales Experience Community (12 Months) ($1,188 value)
                                                </Typography>
                                            </Box>

                                            {/* Item 6: Sales Experience Digital Book */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    Sales Experience Digital Book
                                                </Typography>
                                            </Box>

                                            {/* Item 7: AI Webinar Builder */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    AI Webinar Builder
                                                </Typography>
                                            </Box>

                                            {/* Item 8: Expert Platform Migration */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '100%', flex: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            color: '#1f2937',
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        Expert Platform Migration ($1,000 value)
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            color: '#6B7280',
                                                            fontSize: '13px',
                                                            fontWeight: 400,
                                                            ml: 0,
                                                        }}
                                                    >
                                                        Complete migration of webinars, contacts & automations with setup, testing & QA
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Item 9: Go-To-Market Strategy Audit */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '100%', flex: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            color: '#1f2937',
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        Go-To-Market Strategy Audit ($2,000 value)
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            color: '#6B7280',
                                                            fontSize: '13px',
                                                            fontWeight: 400,
                                                            ml: 0,
                                                        }}
                                                    >
                                                        Personalized funnel audit with a clear action plan to boost conversions
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>

                                {/* Savings Breakdown Section - Three Horizontal Boxes */}
                                <Box sx={{ mt: '24px' }}>
                                    <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: '18px',
                                                fontWeight: 700,
                                                mb: '16px',
                                            }}
                                        >
                                            Savings Breakdown
                                        </Typography>
                                        <Box sx={{ display: 'flex', gap: '12px', flexDirection: { xs: 'column', sm: 'row' } }}>
                                            {/* Total Value Box */}
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    backgroundColor: '#F5F5F5',
                                                    borderRadius: '8px',
                                                    padding: '16px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        mb: '8px',
                                                    }}
                                                >
                                                    Total Value:
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '24px',
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    $9,664+
                                                </Typography>
                                            </Box>

                                            {/* You Save Box - Dark Green */}
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    backgroundColor: '#22B060',
                                                    borderRadius: '8px',
                                                    padding: '16px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: '#ffffff',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        mb: '8px',
                                                    }}
                                                >
                                                    You Save:
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        color: '#ffffff',
                                                        fontSize: '24px',
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    $8,476+
                                                </Typography>
                                            </Box>

                                            {/* You Pay Today Box */}
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    backgroundColor: '#F5F5F5',
                                                    borderRadius: '8px',
                                                    padding: '16px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        mb: '8px',
                                                    }}
                                                >
                                                    You Pay Today:
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '24px',
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    ${currentPlanConfig?.price || 1188}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                        </Box>

                        {/* Right side - Form Section */}
                        <Box
                            sx={{
                                width: { xs: "100%", md: "50%" },
                                bgcolor: "#ffffff",
                                p: { xs: 3, sm: 4, md: 6 },
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: { xs: "18px", md: "0 18px 18px 0" },
                                minHeight: { xs: "500px", md: "auto" },
                            }}
                        >
                            {value === 1 ? (
                                <>
                                    <Box>
                                        {/* Title - Centered */}
                                        <Typography
                                            color="#333333"
                                            fontWeight="700"
                                            fontSize={{ xs: "24px", xl: "30px" }}
                                            lineHeight="normal"
                                            mb="16px"
                                            textAlign="center"
                                        >
                                            Complete your purchase
                                        </Typography>

                                        {/* Bundle Summary - Flex Layout */}
                                        <Box sx={{ 
                                            mb: '14px', 
                                            pb: '20px', 
                                            borderBottom: '1px dashed rgba(163, 163, 163, 0.24)',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start',
                                            gap: '16px',
                                            flexWrap: { xs: 'wrap', sm: 'nowrap' }
                                        }}>
                                            {/* Left Side - Bundle Name and Attendees */}
                                            <Box sx={{ flex: 1 }}>
                                                <Box sx={{ mb: '12px' }}>
                                                    <Typography
                                                        component="span"
                                                        color="#2B2B30"
                                                        fontSize="16px"
                                                        fontWeight={700}
                                                    >
                                                        {currentPlanConfig ? `${currentPlanConfig.planName} Bundle` : 'Professional Plus Bundle'}
                                                    </Typography>
                                                    <Typography
                                                        component="span"
                                                        color="#6B7280"
                                                        fontSize="16px"
                                                        fontWeight={400}
                                                    >
                                                        {' '}(Annual Access)
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: '8px',
                                                    backgroundColor: '#F5F5F5',
                                                    borderRadius: '8px',
                                                    padding: '8px 12px',
                                                    width: 'fit-content',
                                                }}>
                                                    <People sx={{ color: '#6B7280', fontSize: '18px' }} />
                                                    <Typography
                                                        color="#6B7280"
                                                        fontSize="14px"
                                                        fontWeight={500}
                                                    >
                                                        Attendees{' '}
                                                        {(() => {
                                                            const attendeesText = currentPlanConfig?.attendees || '500 Live + 2,500 Automated/month';
                                                            const parts = attendeesText.includes(' + ') 
                                                                ? attendeesText.split(' + ') 
                                                                : [attendeesText];
                                                            
                                                            return parts.map((part, index) => {
                                                                const trimmedPart = part.trim();
                                                                const match = trimmedPart.match(/^([\d,]+)\s+(.+)$/);
                                                                if (match) {
                                                                    const [, number, label] = match;
                                                                    const isLive = label.toLowerCase().includes('live') && !label.toLowerCase().includes('automated');
                                                                    const isAutomated = label.toLowerCase().includes('automated');
                                                                    
                                                                    return (
                                                                        <React.Fragment key={index}>
                                                                            <Typography
                                                                                component="span"
                                                                                sx={{
                                                                                    color: isLive ? '#178EFC' : '#7C3AED',
                                                                                    fontSize: '14px',
                                                                                    fontWeight: 600,
                                                                                }}
                                                                            >
                                                                                {number}
                                                                            </Typography>
                                                                            <Typography
                                                                                component="span"
                                                                                sx={{
                                                                                    color: '#6B7280',
                                                                                    fontSize: '14px',
                                                                                    fontWeight: 500,
                                                                                }}
                                                                            >
                                                                                {' '}{label}
                                                                            </Typography>
                                                                            {index < parts.length - 1 && (
                                                                                <Typography
                                                                                    component="span"
                                                                                    sx={{
                                                                                        color: '#6B7280',
                                                                                        fontSize: '14px',
                                                                                        fontWeight: 500,
                                                                                        mx: '4px',
                                                                                    }}
                                                                                >
                                                                                    {' '}+{' '}
                                                                                </Typography>
                                                                            )}
                                                                        </React.Fragment>
                                                                    );
                                                                }
                                                                return null;
                                                            });
                                                        })()}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Right Side - Pricing */}
                                            <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end', mb: '4px' }}>
                                                    <Typography
                                                        color="#6B7280"
                                                        fontSize="16px"
                                                        fontWeight={700}
                                                        sx={{ textDecoration: 'line-through' }}
                                                    >
                                                        ${currentPlanConfig?.regularYearlyPrice || 9664}
                                                    </Typography>
                                                    <Typography
                                                        color="#22B060"
                                                        fontSize="16px"
                                                        fontWeight={700}
                                                    >
                                                        ${currentPlanConfig?.price || 1188}
                                                    </Typography>
                                                </Box>
                                                <Typography
                                                    color="#A3A3A3"
                                                    fontSize="14px"
                                                    fontWeight={400}
                                                >
                                                    Yearly billing
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </>
                            ) : (
                            <>
                                <Box sx={{ position: "relative", textAlign: 'center' }}>
                                    <Typography
                                        color="#333333"
                                        fontWeight="700"
                                        fontSize={{ xs: "24px", xl: "30px" }}
                                        lineHeight="normal"
                                        mb="8px"
                                        display="inline-block"
                                        textAlign="center"
                                        sx={{ position: "relative" }}
                                    >
                                        Create your account
                                    </Typography>
                                </Box>
                                <Box display="flex" gap="12px" mb="24px" flexWrap="wrap" justifyContent="center" alignItems="center">
                                    <>
                                        <Typography
                                            color="#666666"
                                            fontSize="14px"
                                        >
                                            Get full access
                                        </Typography>
                                        <Box borderRadius="50%" width="4px" height="4px" sx={{ background: "#666" }}></Box>
                                        <Typography
                                            color="#666666"
                                            fontSize="14px"
                                        >
                                            Cancel anytime
                                        </Typography>
                                        <Box borderRadius="50%" width="4px" height="4px" sx={{ background: "#666" }}></Box>
                                        <Typography
                                            color="#666666"
                                            fontSize="14px"
                                        >
                                            No hidden fees
                                        </Typography>
                                    </>
                                </Box>
                                </>
                            )}

                            <Box sx={{ width: '100%' }}>
                                <CustomTabPanel value={value} index={1} noPadding>
                                    <Box mb="16px">
                                            <Typography color="#333333" fontSize="14px" fontWeight="500" mb="12px">
                                                Work Email
                                            </Typography>
                                            <TextField
                                                variant="outlined"
                                                name="email"
                                                placeholder="you@company.com"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                error={!!formErrors.email}
                                                helperText={formErrors.email}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: '3px',
                                                        borderColor: '#666666',
                                                    },

                                                    " .MuiInputLabel-root.Mui-focused": {
                                                        color: "inherit",
                                                    },

                                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: '#333333',
                                                        border: '1px solid'
                                                    },

                                                    "& .MuiOutlinedInput-input": {
                                                        padding: '14px 16px',
                                                        background: '#ffffff',
                                                        borderRadius: '8px'
                                                    },
                                                    "&.MuiInputBase-input::placeholder": {
                                                        color: '#333333',
                                                        fontSize: '16px',
                                                        opacity: '0.8'
                                                    },
                                                }}
                                                fullWidth
                                            />
                                        </Box>
                                    {value === 1 && !isTrial ? (
                                        <>
                                            <Box width="100%" mb="4px">
                                                <Typography color="#333333" fontSize="14px" fontWeight="500" mb="12px">
                                                    Card Details
                                                </Typography>
                                                <Box width="100%" sx={{
                                                    position: "relative",
                                                    "& .CbHosted": {
                                                        borderRadius: '3px',
                                                        border: '1px solid rgba(0, 0, 0, 0.23)',
                                                        padding: '14px 16px',
                                                        "&:hover, &--focus": {
                                                            borderColor: '#666666',
                                                        }
                                                    }
                                                }}>
                                                    <CardComponent
                                                        ref={cardRef}
                                                        currency="USD"
                                                        showTestCards={true}
                                                        styles={{
                                                            border: "1px solid #666666",
                                                            base: {
                                                                padding: "14px 16px",
                                                                border: "1px solid #666666",
                                                                fontSize: '16px',
                                                                fontFamily: 'Inter, sans-serif',
                                                                color: '#333333',
                                                                '::placeholder': {
                                                                    color: '#667085',
                                                                },
                                                            },
                                                            invalid: {
                                                                color: '#ff0000',
                                                            },
                                                        }}
                                                        onChange={(status: any) => {
                                                            console.log('Card status:', status);

                                                            if (status.error) {
                                                                setCardError(status.error.message);
                                                                setIsCardValid(false);
                                                            } else if (!status.complete) {
                                                                // Clear error but indicate card is not complete
                                                                setCardError(null);
                                                                setIsCardValid(false);
                                                            } else {
                                                                // Card is complete and valid
                                                                setCardError(null);
                                                                setIsCardValid(true);
                                                            }
                                                        }}
                                                        onReady={() => {
                                                            console.log('Card component ready');
                                                            setIsCardReady(true);
                                                            setIsCardValid(false); // Reset validity when component is ready
                                                        }}
                                                        onBlur={() => {
                                                            console.log('Card component blurred');
                                                        }}
                                                        onFocus={() => {
                                                            console.log('Card component focused');
                                                        }}
                                                    />
                                                </Box>
                                                {cardError && (
                                                    <Typography color="error" fontSize="12px" mt={1}>
                                                        {cardError}
                                                    </Typography>
                                                )}
                                            </Box>
                                            <Box display="flex" justifyContent="end" flexDirection="column">
                                                {!showPromoField ? (
                                                    <>
                                                        {appliedPromo ? (
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    padding: '4px 8px',
                                                                    backgroundColor: '#F0FFF4',
                                                                    borderRadius: '4px',
                                                                    width: 'fit-content',
                                                                    marginLeft: 'auto'
                                                                }}
                                                            >
                                                                <Typography color="#1D9652" fontSize="14px">
                                                                    {appliedPromo.code} applied
                                                                </Typography>
                                                                {/* <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    viewBox="0 0 16 16"
                                                                    fill="none"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        setAppliedPromo(null);
                                                                        setPromoCode('');
                                                                    }}
                                                                >
                                                                    <path d="M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM10.7 11.5L8 8.8L5.3 11.5L4.5 10.7L7.2 8L4.5 5.3L5.3 4.5L8 7.2L10.7 4.5L11.5 5.3L8.8 8L11.5 10.7L10.7 11.5Z" fill="#1D9652" />
                                                                </svg> */}
                                                            </Box>
                                                        ) : (
                                                            null
                                                            // <Typography
                                                            //     color="#2B2B30"
                                                            //     fontSize="16px"
                                                            //     display="flex"
                                                            //     justifyContent="end"
                                                            //     mb="8px"
                                                            //     sx={{
                                                            //         cursor: 'pointer',
                                                            //         '&:hover': {
                                                            //             textDecoration: 'underline'
                                                            //         }
                                                            //     }}
                                                            //     onClick={() => setShowPromoField(true)}
                                                            // >
                                                            //     Have a promo code?
                                                            // </Typography>
                                                        )}
                                                    </>
                                                ) : (
                                                    <TextField
                                                        variant="outlined"
                                                        placeholder="Promo Code:"
                                                        value={promoCode}
                                                        onChange={(e) => {
                                                            setPromoCode(e.target.value);
                                                            setPromoError('');
                                                        }}
                                                        error={!!promoError}
                                                        helperText={promoError}
                                                        sx={{
                                                            width: "100%",
                                                            marginBottom: "25px",
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: '3px',
                                                                borderColor: '#C7C7C7',
                                                                background: '#ffffff',
                                                                paddingRight: '0'
                                                            },
                                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: '#333333',
                                                                border: '1px solid'
                                                            },
                                                            "& .MuiOutlinedInput-input": {
                                                                padding: '14px 16px',
                                                                background: '#ffffff',
                                                                borderRadius: '8px'
                                                            },
                                                            "&.MuiInputBase-input::placeholder": {
                                                                color: '#333333',
                                                                fontSize: '16px',
                                                                opacity: '0.8'
                                                            },
                                                        }}
                                                        slotProps={{
                                                            input: {
                                                                endAdornment: (
                                                                    <InputAdornment
                                                                        position="end"
                                                                        sx={{
                                                                            ".MuiTypography-root": {
                                                                                color: "#333333",
                                                                                fontWeight: "500",
                                                                                fontSize: "16px",
                                                                            },
                                                                            paddingRight: "10px",
                                                                        }}
                                                                    >
                                                                        <Box display="flex" justifyContent="center" alignItems="center">
                                                                            <Box
                                                                                sx={{
                                                                                    background: theme.palette.primary.main,
                                                                                    borderRadius: '4px',
                                                                                    padding: '4px 10px',
                                                                                    marginRight: '4px',
                                                                                    minWidth: '57px',
                                                                                    fontSize: '14px',
                                                                                    fontWeight: '500',
                                                                                    color: '#fff',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                                onClick={() => validateCoupon()}
                                                                            >
                                                                                Apply
                                                                            </Box>
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="17"
                                                                                height="16"
                                                                                viewBox="0 0 17 16"
                                                                                fill="none"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    setShowPromoField(false);
                                                                                    setPromoError('');
                                                                                }}
                                                                            >
                                                                                <path d="M8.07324 1C4.17324 1 1.07324 4.1 1.07324 8C1.07324 11.9 4.17324 15 8.07324 15C11.9732 15 15.0732 11.9 15.0732 8C15.0732 4.1 11.9732 1 8.07324 1ZM10.7732 11.5L8.07324 8.8L5.37324 11.5L4.57324 10.7L7.27324 8L4.57324 5.3L5.37324 4.5L8.07324 7.2L10.7732 4.5L11.5732 5.3L8.87324 8L11.5732 10.7L10.7732 11.5Z" fill="#A3A3A3" />
                                                                            </svg>
                                                                        </Box>
                                                                    </InputAdornment>
                                                                ),
                                                            },
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </>
                                    ) : null}
                                    {/* Custom URL field hidden */}
                                    <Box sx={{
                                        flex: 1, position: 'relative', '@media (max-width: 768px)': {
                                            width: '100%',
                                        }
                                    }} display="flex" flexDirection="column" justifyContent="space-between">
                                        <Box>
                                            <Box display="flex" gap={{ xs: "13px", sm: "119px" }} justifyContent="center" alignItems="center" mt={{ xs: "20px", md: '24px' }}>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleGetStarted}
                                                    className="x-large-btn"
                                                    disabled={isLoading || (!isTrial && !isCardValid)}
                                                    disableElevation
                                                    fullWidth
                                                    sx={{
                                                        textTransform: "none",
                                                        px: "44px",
                                                        height: "47px!important",
                                                        fontSize: "16px",
                                                        fontWeight: 500,
                                                        bgcolor: value === 1 && !isTrial && !isCardValid ? "#cccccc !important" : "#0382F7 !important",
                                                        color: value === 1 && !isTrial && !isCardValid ? "#666666 !important" : "#ffffff !important",
                                                        "&:hover": { 
                                                            bgcolor: value === 1 && !isTrial && !isCardValid ? "#cccccc !important" : "#006dd1 !important" 
                                                        },
                                                        "&.Mui-disabled": {
                                                            bgcolor: "#cccccc !important",
                                                            color: "#666666 !important"
                                                        }
                                                    }}
                                                >
                                                    {isLoading ? (
                                                        <CircularProgress size={24} sx={{ color: value === 1 && !isTrial && !isCardValid ? '#666666' : 'white' }} />
                                                    ) : value === 1 && !isTrial && !isCardValid ? (
                                                        'Please Complete Card Details'
                                                    ) : (
                                                        'Start your subscription'
                                                    )}
                                                </Button>
                                            </Box>
                                            
                                        </Box>
                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                mt: 2,
                                                mb: 2
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: 400,
                                                    lineHeight: 1.5,
                                                    mt: 2,
                                                }}
                                            >
                                                By completing this step, you agree to our <a href="https://easywebinar.com/terms-conditions/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Terms of Service</a> and <a href="https://easywebinar.com/privacy/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Privacy Policy</a>
                                            </Typography>
                                        </Box>

                                        {/* G2 Badges Section - Moved to Right Side */}
                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                mt: 4,
                                                px: 2,
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: '#000000',
                                                    fontSize: { xs: '14px', md: '16px' },
                                                    lineHeight: 1.4,
                                                    mb: 2,
                                                    textAlign: 'center',
                                                    maxWidth: '500px',
                                                    mx: 'auto'
                                                }}
                                            >
                                                Recognized by customers across the world as a leader in multiple categories on G2
                                            </Typography>

                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    flexWrap: { xs: 'wrap', md: 'nowrap' },
                                                    gap: { xs: 2, md: 3 },
                                                    maxWidth: '100%',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                <img
                                                    src="https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5.png"
                                                    srcSet="
                                                        https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5.png 1x,
                                                        https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5-2x.png 2x,
                                                        https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5-3x.png 3x
                                                    "
                                                    alt="G2 Badges - High Performer, Users Love Us, High Performer Asia Pacific, Leader Small Business, Momentum Leader"
                                                    style={{
                                                        maxWidth: '500px',
                                                        height: 'auto',
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                </CustomTabPanel>
                            </Box>
                        </Box >
                    </Box >
                </Box >
            </Box>
            <AccountVerification
                onClose={handleVerificationDialogClose}
                open={verificationDialogOpen}
                onProceed={handleVerificationDialogProceed}
                phoneNumber=""
                email={formData.email}
                password={formData.password}
                companyId={verificationData.companyId}
                companyName={verificationData.companyName}
                infLeadSquaredId={verificationData.infLeadSquaredId}
            />
        </>
    )
}
export default WorkshopBundleAnnual
